import { render, staticRenderFns } from "./SurgeryError.vue?vue&type=template&id=03b926b9&scoped=true"
var script = {}
import style0 from "./SurgeryError.vue?vue&type=style&index=0&id=03b926b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b926b9",
  null
  
)

export default component.exports